import React from 'react';
import { connect } from 'react-redux';
import { setAddress } from '../../address/actions';
import Address from 'scy/Address';

function LandingPageAddress({
  autoFocus,
  scrollOnSubmit,
  onSuccess,
  trackingParams,
  className,
  id,
  setAddress
}) {
  function handleSuccess(address) {
    setAddress(address, trackingParams).then(() => {
      if (scrollOnSubmit) window.scrollTo(0, 0);
      if (onSuccess) onSuccess();
    });
  }

  return (
    <Address
      onSuccess={handleSuccess}
      autoFocus={autoFocus}
      scrollOnMobileFocus
      className={className}
      id={id}
    />
  );
}

function mapStateToProps() {
  return {};
}

export default connect(
  mapStateToProps,
  { setAddress }
)(LandingPageAddress);
